const config = {
  breakpoints: ['40rem', '52rem', '64rem', '96rem', '128rem'],
  text: {
    sm: {
      fontSize: ['0.875rem', null, '1.125rem', '1rem'],
    },
    normal: {
      // p
      fontSize: ['1rem', null, '1.125rem', '1.25rem'],
    },
    lg: {
      // h4
      fontSize: ['1.25rem', null, '1.5rem', '1.75rem'],
    },
    xl: {
      // h3
      fontSize: ['2rem', null, '1.75rem', '2.25rem'],
    },
    xxl: {
      // h1
      fontSize: ['1.75rem', null, '2rem', '2.75rem'],
    },
  },
};

export default config;